<h2 mat-dialog-title>{{ 'Kutyafajta' | translate }}</h2>
<mat-dialog-content>
  <p *ngIf="breedForm.value.id">
    {{ 'Kutyafajta módosítása' | translate }}
  </p>
  <p *ngIf="!breedForm.value.id">
    {{ 'Új kutyafajta' | translate }}
  </p>

  <form [formGroup]="breedForm">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'Kutyafajta' | translate }}</mat-label>
      <input
        formControlName="en"
        matInput
        [placeholder]="'Kutyafajta' | translate" />
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">{{ 'Mégse' | translate }}</button>
  <button
    mat-button
    color="primary"
    [mat-dialog-close]="breedForm.value"
    [disabled]="!breedForm.valid">
    <span *ngIf="breedForm.value.id" translate>{{
      'Módosítás' | translate
    }}</span>
    <span *ngIf="!breedForm.value.id" translate>{{
      'Létrehozás' | translate
    }}</span>
  </button>
</mat-dialog-actions>
